module.exports = __webpack_public_path__ + "static/media/wizualizacja-97.128ad102.png";